import { Fragment } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import { Icon } from 'lmcv/components/Icon'

import { ListSkeleton } from './ListSkeleton'
import { ListElement, TextTitle, ItemPoints, ContentElement, CircleElement, Infos, TextDate, TextPoints } from './styles'

function List ({ data, isLoading, isGetting }) {
  const renderList = items => {
    return !items.length
      ? (
      <TextTitle>Você não possui pontos</TextTitle>
        )
      : (
      <ListElement>
        {items.map((balance, index) => (
          <ItemPoints key={`${balance.id}-${index}`}>
            <ContentElement>
              <CircleElement data-circle="circle">
                <Icon name={balance.transaction_icon} />
              </CircleElement>

              <Infos>
                <TextDate>
                  {dayjs(balance.date).format('ddd, DD/MM')} às{' '}
                  {dayjs(balance.date).format('HH:mm')}
                </TextDate>
                <TextTitle>{balance.title}</TextTitle>
              </Infos>
            </ContentElement>

            <TextPoints>
              {balance.transaction_type === 'credit' ? '+' : '-'}{' '}
              {balance.points} pts
            </TextPoints>
          </ItemPoints>
        ))}
      </ListElement>
        )
  }

  return (
    <Fragment>
      {isLoading ? <ListSkeleton /> : renderList(data)}
      {isGetting && <ListSkeleton />}
    </Fragment>
  )
}

List.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isGetting: PropTypes.bool.isRequired
}

export default List
